export const required = 'Required';
export const minlength = 'Field must have at least {requiredLength} characteres';
export const maxlength = 'Field must have at most {requiredLength} characteres';
export const email = 'Field must have a valid email';
